module.exports = __webpack_public_path__ + "static/media/reader_disket_casset.6cd9b6f9.ico";